/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Header_TitleInputs */

const es_billing_header_title = /** @type {(inputs: Billing_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación y uso`)
};

const en_billing_header_title = /** @type {(inputs: Billing_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing & Usage`)
};

/**
* | output |
* | --- |
* | "Billing & Usage" |
*
* @param {Billing_Header_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_header_title = /** @type {((inputs?: Billing_Header_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Header_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_header_title(inputs)
	return en_billing_header_title(inputs)
});
export { billing_header_title as "billing.header.title" }